import { List, ListItem, ListItemIcon, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import React from "react";

const PREFIX = "BankFindQuickTips";

const classes = {
  MuiSvgIcon: `${PREFIX}-MuiSvgIcon`,
  quickTips: `${PREFIX}-quickTips`,
  tips: `${PREFIX}-tips`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.MuiSvgIcon}`]: {
    color: theme.palette.primary.main,
    fontSize: "10px",
  },

  [`&.${classes.quickTips}`]: {
    "margin": "0 .5rem",
    "& div": {
      minWidth: 20,
    },
    "& ul": {
      "padding": 0,
      "& li": {
        padding: "0px .875rem",
        marginBottom: ".875rem",
      },
    },
  },

  [`& .${classes.tips}`]: {
    fontSize: "1rem",
  },
}));

const quickTips = [
  "A complete list of active and inactive institutions can be generated by clicking the search button without entering filtering criteria",
  "You can narrow your focus for highly targeted searches. The more input you give, the fewer results you’ll receive",
  "Simple searches, like a partial name instead of a whole, will produce more results",
  "Adjust your search input if you’re not getting the results you expected",
  "Reduce typing by taking advantage of auto-complete suggestions",
  "All fields are optional. You do not need to fill in every line",
];

export default function QuickTips() {
  return (
    <Root className={classes.quickTips} id={"quick-tips"}>
      <Typography variant="h2">Quick Tips:</Typography>
      <List>
        {quickTips.map((tip, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <FiberManualRecordIcon className={classes.MuiSvgIcon} />
            </ListItemIcon>
            <Typography className={classes.tips}>{tip}</Typography>
          </ListItem>
        ))}{" "}
      </List>
    </Root>
  );
}
